module.exports = __webpack_public_path__ + "static/media/ep3.437cb907.jpg";